class WalletEvents {
  constructor(target = window) {
    this.target = target; // The element to dispatch and listen on
  }

  // Trigger a wallet connecting event
  triggerWalletConnecting(details = {}) {
    const event = new CustomEvent("wallet:connecting", {
      detail: { status: "loading", ...details, timestamp: Date.now() },
    });
    this.target.dispatchEvent(event);
  }

  // Trigger a wallet connected event
  triggerWalletConnected(details = {}) {
    const event = new CustomEvent("wallet:connected", {
      detail: { status: "success", ...details, timestamp: Date.now() },
    });
    this.target.dispatchEvent(event);
  }

  // Trigger a wallet connection failed event
  triggerWalletConnectionFailed(details = {}) {
    const event = new CustomEvent("wallet:connectionFailed", {
      detail: { status: "error", ...details, timestamp: Date.now() },
    });
    this.target.dispatchEvent(event);
  }

  // Add an event listener
  on(eventType, callback) {
    this.target.addEventListener(eventType, callback);
  }

  // Remove an event listener
  off(eventType, callback) {
    this.target.removeEventListener(eventType, callback);
  }
}

export const walletEvents = new WalletEvents();
